export default __webpack_public_path__ + "static/media/Oracle.9b57bb0a.svg";